<template>
  <div>
    <div class="row">
      <div class="col-md-12">
        <loading v-if="showContent"></loading>
        <h1 class="titulo">{{ title }}</h1>
        <br>
        <div class="pagina-customizada" v-html="html"></div>
        <!--<album-interno></album-interno>-->
      </div>
    </div>
  </div>
</template>
<script type="text/javascript">
  import {get, post} from '../helpers/api';
  import AlbumInterno from "../components/interno/AlbumInterno";
  import Loading from '../components/common/Loading.vue';

  export default {
    components: {
      AlbumInterno,
      Loading
    },
    data() {
      return {
        title: '',
        content: '',
        html: '',
        externalItems: '',
        showContent: true,
        checked: '',
      }
    },
    mounted() {

      let self = this;
      get('pagina/' + this.$route.params.page).then(function (response) {
        self.title = response.data.result.data.name;
        //self.content = response.data.result.data.html;
        self.html = response.data.result.data.html;
        self.externalItems = response.data.result.data.externalItems;
        self.showContent = false;
      });

      $(document.body).on('click', '.btnPollRequest', function () {
        let pollIdItem = $('input[type="radio"][name="option"]:checked').val();
        swal.fire({
          text: 'Carregando...',
          buttons: false,
        })
        if (typeof pollIdItem === 'undefined') {
          // alert('Selecione uma opção');
          swal.fire({
            title: "Selecione uma opção.",
            icon: "error",
          });
          return false;
        }
        post('polling', {pollId: pollIdItem}).then(function () {
          // alert('Votação efetuada com sucesso.');
          swal.fire({
            title: "Votação efetuada com sucesso.",
            icon: "success",
          });
          $(".enquetecustom").html("Votação efetuada com sucesso.")
          return false;
        }).catch(function () {
          swal.fire({
            title: "Ocorreu um erro ao enviar o pedido, tente novamente mais tarde.",
            icon: "error",
          });
          return false;
        });
      });

      $(document.body).on('click', '.btnFormRequest', function () {
        var buttomId = $(this)[0].id;
        // $("#" + buttomId).attr('disabled', 'disabled');
        swal.fire({
          text: 'Carregando...',
          buttons: false,
        });
        event.preventDefault();
        let values = {};
        let formextenal = $(this).closest('form')[0].id;
        var erroValid = false;
        var fieldsRequired = false;

        $('#' + formextenal + ' :input').each(function () {
          var input = $(this);
          if (input[0].required) {
            if (!input[0].value) {
              fieldsRequired = true;
              erroValid = true;
            }
          }
        });
        if (fieldsRequired) {
          // alert("favor preencher todos campos obrigatórios");
          swal.fire({
            title: "favor preencher todos campos obrigatórios.",
            icon: "error",
          });
          $("#" + buttomId).removeAttr('disabled');
        }
        if (!erroValid) {
          $.each($('#' + formextenal).serializeArray(), function (i, field) {
            values[field.name] = field.value;
          });
          post('request-form', {data: values}).then(function (response) {
            // alert('Email enviado com sucesso.');
            swal.fire({
              title: "Email enviado com sucesso.",
              icon: "success",
            });
            $("#" + buttomId).removeAttr('disabled');
            $('#' + formextenal)[0].reset();
            return false;
          }).catch(function () {
            // alert('Houve um erro ao tentar enviar seu formulário, tente novamente mais tarde.');
            swal.fire({
              title: "Houve um erro ao tentar enviar seu formulário, tente novamente mais tarde.",
              icon: "error",
            });
            // $("#" + buttomId).removeAttr('disabled');
            $('#' + formextenal)[0].reset();
            return false;
          });
        }
      });
    },
    watch: {
      $route(to) {
        let self = this;
        this.title = '';
        this.content = '';
        if(to.name == "internas"){
          get('pagina/' + this.$route.params.page).then(function (response) {
            self.title = response.data.result.data.name;
            //self.content = response.data.result.data.html;
            self.html = response.data.result.data.html;
            self.externalItems = response.data.result.data.externalItems;
          });
        }
      }
    },
    methods: {
    }
  }
</script>


// WEBPACK FOOTER //
// src/views/Internas.vue